import { render, staticRenderFns } from "./ContentTable.vue?vue&type=template&id=97fef65a&"
import script from "./ContentTable.js?vue&type=script&lang=js&"
export * from "./ContentTable.js?vue&type=script&lang=js&"
import style0 from "./ContentTable.scss?vue&type=style&index=0&prod&lang=scss&module=true&"
import style1 from "./ContentTable.scss?vue&type=style&index=1&prod&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports